import { getExamFaceDetection, updateFaceDetection } from '@/service/course/report';
export default {
    data: function () {
        return {
            faceDetectionDetail: [],
            dataFaceDeteail: [],
            checkDetection: null,
        };
    },
    props: {
        isOpen: {
            type: Boolean,
        },
        isClose: {
            type: Function,
        },
        ticketId: {
            type: String
        },
    },
    watch: {
        isOpen: async function (newValue) {
            if (newValue) {
                console.log(this.ticketId)


                this.getFaceDetail();
            }
        },
    },
    methods: {
        async getFaceDetail() {
            this.faceDetectionDetail = [];
            this.data = {
                idticket: this.ticketId
            }
            this.getFaceDetection();
        },
        async getFaceDetection() {
            this.faceDetectionDetail = [];
            let result = await getExamFaceDetection(this.data)
            this.dataFaceDeteail = result;

            this.faceDetectionDetail.push({
                imageFaceuser: result.imagefaceuser,
                arrayFaceDetection: result.arrayFace,
                fullName: result.firstName + ' ' + result.lastName,
                email: result.email,
                examDate:
                    new Date(result.created_at).toDateString() +
                    ' ' +
                    new Date(result.created_at).toLocaleTimeString(),
                statusFace: result.statusFace,

            });

            let arrFace = [];
            this.faceDetectionDetail[0].arrayFaceDetection.forEach(face => {
                switch (face.status) {
                    case 'skip_by_user':
                        face.status = 'skip_by_user';
                        break;
                    case 'take_photo':
                        face.status = 'take_photo';
                        break;
                    case 'detected_success':
                        face.status = true;
                        break;
                    case 'detected_fail':
                        face.status = false;
                        break;

                }
                arrFace.push({
                    ...face,
                    boolCheck: false,
                });


            });
            this.faceDetectionDetail[0].arrayFaceDetection = arrFace;
            console.log(this.faceDetectionDetail)

        },

        checkChange(item) {
            item.boolCheck = true;
            console.log(item)
        },

        async confirmChange(item) {
            console.log("confirmChange -> item", item)

            switch (item.status) {
                case 'skip_by_user':
                    item.status = await 'skip_by_user';
                    break;
                case 'take_photo':
                    item.status = await 'take_photo';
                    break;
                case true:
                    item.status = await 'detected_success';
                    break;
                case false:
                    item.status = await 'detected_fail';
                    break;
            }

            let data = {
                idface: item._id,
                status: item.status,
                idticket: this.ticketId
            }
            let result = await updateFaceDetection(data)
            console.log("confirmChange -> result", result)

            this.getFaceDetail();
        },
    },

}